/**
 * Lowercases and strips combining diacritics so column search is
 * accent-insensitive in both directions ("poznamka" ↔ "Poznámka").
 * NFD splits accented letters into base char + combining mark; the combining
 * marks (U+0300–U+036F) are then dropped. Letters whose accent is not a
 * combining mark (e.g. Polish "ł") are intentionally left as-is.
 */
export const normalizeSearchText = (text: string): string =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
